import Model, { valueWithArray } from 'ducker-model';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import { formatDate } from '@fund/basic-lib/dist/lib/date';
import format from '../utils/detail-format';
import commonModel from './common.model';

const property = {
  fundCode: String,
  fundName: String,
  indexCode: String,
  indexName: String,
  headerTags: String, // 头部标签
  bigDataListTag: Object, // 大数据榜单标签
  indexInfo: Object, // 指数信息
  indexValuationInfo: Object, // 指数估值信息
  stageRiseList: valueWithArray(Object), // 阶段涨幅列表
  isUpdating: Object, // 是否正在更新
  fixedInvestList: Number, // 定投列表
  bestFixedInvestStrategy: String, // 最佳定投策略
  yPensionFundCode: String, // Y类养老基金代码
  benchmark: String, // 比较基准
  valuationBias: Number, // 估值偏差
  fundArchives: Object, // 基金档案
  currentFundManager: valueWithArray(Object), // 当前基金经理
  lastManagerChangeDate: Object, // 最近一次基金经理变动时间
  investIdea: String, // 投资理念
  fundHoldInfo: Number, // 基金持仓需要的一些信息  资产 披露日期
  featureData: Number, // 基金特色数据
  tradeRule: String, // 交易规则
  newFundTradeRule: String, // 新基金交易规则
  fundBonusPoints: Object, // 基金分红提示
  newMarketCode: String, // 新市场代码
  fundAcRate: Object, // 基金AC费率
  assistantInfo: Object, // 智能助理信息
  bottomMoreInfo: String, // 底部更多信息
  bottomRateInfo: String, // 底部费率信息
  bottomBuyInfo: String, // 底部购买信息
  isStopTrade: String, // 是否是暂停申赎和封闭期基金
  isStopSH: String, // 是否是暂停赎回基金
  minSG: String, // 最小申购金额
  minSBSG: String, // 最小追加申购金额
  warnList: valueWithArray(Object), // 风险提示列表（巨额赎回）
  newFundBuyProgressInfo: String, // 新基金购买流程信息
  isSpecialRate: String, // 是否是特殊费率
  indexMarketInfo: String, // 指数行情信息
  fundCompany: String, // 基金公司
  fundRelateTheme: valueWithArray(Object), // 基金关联主题
  companyId: String, // 基金公司id
};

const replacedKeyFromPropertyName = {
  fundCode: 'baseInfo[0].FCODE',
  fundName: 'baseInfo[0].SHORTNAME',
  indexCode: 'baseInfo[0].INDEXCODE',
  indexName: 'baseInfo[0].INDEXNAME',
  headerTags: { // 头部标签
    property: ['baseInfo[0].FTYPE',
      'baseInfo[0].FCODE',
      'baseInfo[0].BAGTYPE',
      'baseInfo[0].RISKLEVEL',
      'baseInfo[0].RLEVEL_CX',
      'baseInfo[0].SHORTNAME',
      'baseInfo[0].TTYPENAME',
      'baseInfo[0].TTYPE'],
    computed: ([fType,
      fundCode,
      bagType,
      riskLevel,
      rLevelCx,
      fundName,
      tTypeName,
      tType]) => format.handleHeaderTags({
      fType, fundCode, bagType, riskLevel, rLevelCx, fundName, tTypeName, tType,
    }),
  },
  bigDataListTag: 'uniqueInfo[0].LABELINFO[0]',
  indexInfo: { // 指数信息
    property: ['baseInfo[0].INDEXNAME',
      'baseInfo[0].FCODE',
      'baseInfo[0].INDEXCODE',
      'baseInfo[0].LINKZSB',
      'indexDetail[0].INDEXVALUA'],
    computed: ([indexName, fundCode, indexCode, linkZsb, indexValue]) => ({
      indexName, fundCode, indexCode, linkZsb, indexValue,
    }),
  },
  indexValuationInfo: { // 指数估值信息
    property: ['baseInfo[0].INDEXNAME',
      'baseInfo[0].INDEXCODE',
      'indexDetail[0].INDEXVALUA',
      'indexDetail[0].PEP100',
    ],
    computed: (([indexName, indexCode, indexValue, pep100]) => ({
      indexName, indexCode, indexValue, pep100,
    })),
  },
  stageRiseList: { // 阶段涨幅列表
    property: 'FundPeriodIncrease',
    computed: (list) => commonModel.stageRiseModel.objectArrayWithKeyValuesArray(list),
  },
  isUpdating: { // 是否正在更新
    property: 'FundPeriodIncreaseExpansion',
    computed: (expansion) => (isEmpty(expansion) ? false : expansion?.ISUPDATING),
  },
  fixedInvestList: { // 定投列表
    property: ['baseInfo[0].PTDT_Y',
      'baseInfo[0].PTDT_TWY',
      'baseInfo[0].PTDT_TRY',
      'baseInfo[0].PTDT_FY',
      'baseInfo[0].DWDT_Y',
      'baseInfo[0].DWDT_TWY',
      'baseInfo[0].DWDT_TRY',
      'baseInfo[0].DWDT_FY',
      'baseInfo[0].MBDT_Y',
      'baseInfo[0].MBDT_TWY',
      'baseInfo[0].MBDT_TRY',
      'baseInfo[0].MBDT_FY',
      'baseInfo[0].YDDT_Y',
      'baseInfo[0].YDDT_TWY',
      'baseInfo[0].YDDT_TRY',
      'baseInfo[0].YDDT_FY',
      'baseInfo[0].BESTDT_Y',
      'baseInfo[0].BESTDT_TWY',
      'baseInfo[0].BESTDT_TRY',
      'baseInfo[0].BESTDT_FY',
      'baseInfo[0].BFUNDTYPE'],
    computed: (([ptdtY,
      ptdtTwy,
      ptdtTry,
      ptdtFy,
      dwdtY,
      dwdtTwy,
      dwdtTry,
      dwdtFy,
      mbdtY,
      mbdtTwy,
      mbdtTry,
      mbdtFy,
      yddtY,
      yddtTwy,
      yddtTry,
      yddtFy,
      bestDtY,
      bestDtTwy,
      bestDtTry,
      bestDtFy,
      bFundType]) => format.handleFixedInvestList({
      ptdtY,
      ptdtTwy,
      ptdtTry,
      ptdtFy,
      dwdtY,
      dwdtTwy,
      dwdtTry,
      dwdtFy,
      mbdtY,
      mbdtTwy,
      mbdtTry,
      mbdtFy,
      yddtY,
      yddtTwy,
      yddtTry,
      yddtFy,
      bestDtY,
      bestDtTwy,
      bestDtTry,
      bestDtFy,
      bFundType,
    })),
  },
  bestFixedInvestStrategy: { // 最佳定投策略
    property: 'baseInfo[0].BESTDT_STRATEGY',
    computed: (value) => {
      const config = {
        1: '定期定额+目标止盈',
        2: '定期定额+移动止盈',
        3: '指数估值定投+移动止盈',
        4: '指数估值定投+不止盈',
        5: '指数估值定投+目标止盈',
        6: '成本定投+不止盈',
        7: '成本定投+目标止盈',
        8: '成本定投+移动止盈',
      };
      return config[value];
    },
  },
  yPensionFundCode: 'baseInfo[0].YMATCHCODEA', // Y类养老基金代码
  benchmark: 'baseInfo[0].BENCH', // 比较基准
  valuationBias: { // 估值偏差
    property: 'baseInfo[0].ESTDIFF',
    computed: (estDiff) => (isEmpty(estDiff) ? '--' : numeral(estDiff).format('0.00')),
  },
  fundArchives: { // 基金档案
    property: ['baseInfo[0].ESTABDATE',
      'baseInfo[0].JJGS',
      'baseInfo[0].JJGSID',
      'baseInfo[0].ENDNAV'],
    computed: ([estabDate, jjgs, jjgsId, endNav]) => ({
      estabDate: !isEmpty(estabDate) ? estabDate : '等待成立',
      company: !isEmpty(jjgs) ? jjgs : '--',
      companyId: !isEmpty(jjgsId) ? jjgsId : '--',
      fundSize: !isEmpty(endNav) ? format.formatFundSize(endNav) : '--',
    }),
  },
  currentFundManager: { // 当前基金经理
    property: 'FundManagerInformation.currentManagerInfos',
    computed: (list) => commonModel.fundManagerModel.objectArrayWithKeyValuesArray(list),
  },
  lastManagerChangeDate: { // 最近一次基金经理变动时间
    property: 'FundManagerInformation.historyManagerInfos[0]',
    computed: (historyFundManager) => {
      const date = historyFundManager?.SINFO?.FempDate;
      return isEmpty(date) ? '--' : formatDate(new Date(date.replace(/-/g, '/')), 'yyyy-MM-dd');
    },
  },
  investIdea: { // 投资理念
    property: ['cfhFInfo[0].INVESTMENTIDEAR', 'cfhFInfo[0].INVESTMENTIDEARIMG'],
    computed: ([investmentIdea, investmentIdeaImg]) => ({
      investmentIdea: !isEmpty(investmentIdea) ? investmentIdea : '--',
      investmentIdeaImg: !isEmpty(investmentIdeaImg) ? investmentIdeaImg : '--',
    }),
  },
  fundHoldInfo: { // 基金持仓需要的一些信息  资产 披露日期
    property: ['baseInfo[0].ENDNAV', 'baseInfo[0].FEGMRQ'],
    computed: ([nav, date]) => ({
      value: (nav - 0).toFixed(2),
      valueFormat: format.formatFundSize(nav),
      date,
    }),
  },
  featureData: { // 基金特色数据
    property: ['uniqueInfo[0].STDDEV1',
      'uniqueInfo[0].STDDEV_1NRANK',
      'uniqueInfo[0].STDDEV_1NFSC',
      'uniqueInfo[0].STDDEV3',
      'uniqueInfo[0].STDDEV_3NRANK',
      'uniqueInfo[0].STDDEV_3NFSC',
      'uniqueInfo[0].STDDEV5',
      'uniqueInfo[0].STDDEV_5NRANK',
      'uniqueInfo[0].STDDEV_5NFSC',
      'uniqueInfo[0].SHARP1',
      'uniqueInfo[0].SHARP_1NRANK',
      'uniqueInfo[0].SHARP_1NFSC',
      'uniqueInfo[0].SHARP3',
      'uniqueInfo[0].SHARP_3NRANK',
      'uniqueInfo[0].SHARP_3NFSC',
      'uniqueInfo[0].SHARP5',
      'uniqueInfo[0].SHARP_5NRANK',
      'uniqueInfo[0].SHARP_5NFSC',
      'uniqueInfo[0].MAXRETRA1',
      'uniqueInfo[0].MAXRETRA_1NRANK',
      'uniqueInfo[0].MAXRETRA_1NFSC',
      'uniqueInfo[0].MAXRETRA3',
      'uniqueInfo[0].MAXRETRA_3NRANK',
      'uniqueInfo[0].MAXRETRA_3NFSC',
      'uniqueInfo[0].MAXRETRA5',
      'uniqueInfo[0].MAXRETRA_5NRANK',
      'uniqueInfo[0].MAXRETRA_5NFSC',
      'uniqueInfo[0].TRKERROR1',
      'uniqueInfo[0].TRKERROR_1NRANK',
      'uniqueInfo[0].TRKERROR_1NFSC',
      'uniqueInfo[0].TRKERROR3',
      'uniqueInfo[0].TRKERROR_3NRANK',
      'uniqueInfo[0].TRKERROR_3NFSC',
      'uniqueInfo[0].TRKERROR5',
      'uniqueInfo[0].TRKERROR_5NRANK',
      'uniqueInfo[0].TRKERROR_5NFSC',
      'baseInfo[0].BTYPE'],
    computed: ([STDDEV1,
      STDDEV_1NRANK,
      STDDEV_1NFSC,
      STDDEV3,
      STDDEV_3NRANK,
      STDDEV_3NFSC,
      STDDEV5,
      STDDEV_5NRANK,
      STDDEV_5NFSC,
      SHARP1,
      SHARP_1NRANK,
      SHARP_1NFSC,
      SHARP3,
      SHARP_3NRANK,
      SHARP_3NFSC,
      SHARP5,
      SHARP_5NRANK,
      SHARP_5NFSC,
      MAXRETRA1,
      MAXRETRA_1NRANK,
      MAXRETRA_1NFSC,
      MAXRETRA3,
      MAXRETRA_3NRANK,
      MAXRETRA_3NFSC,
      MAXRETRA5,
      MAXRETRA_5NRANK,
      MAXRETRA_5NFSC,
      TRKERROR1,
      TRKERROR_1NRANK,
      TRKERROR_1NFSC,
      TRKERROR3,
      TRKERROR_3NRANK,
      TRKERROR_3NFSC,
      TRKERROR5,
      TRKERROR_5NRANK,
      TRKERROR_5NFSC,
      BTYPE]) => {
      const data = {
        oneYear: {
          volatility: {
            value: STDDEV1,
            rank: STDDEV_1NRANK,
            NumberOfSamples: STDDEV_1NFSC,
          },
          sharp: {
            value: SHARP1,
            rank: SHARP_1NRANK,
            NumberOfSamples: SHARP_1NFSC,
          },
          maxReturn: {
            value: MAXRETRA1,
            rank: MAXRETRA_1NRANK,
            NumberOfSamples: MAXRETRA_1NFSC,
          },
          trackingError: {
            value: TRKERROR1,
            rank: TRKERROR_1NRANK,
            NumberOfSamples: TRKERROR_1NFSC,
          },
        },
        threeYear: {
          volatility: {
            value: STDDEV3,
            rank: STDDEV_3NRANK,
            NumberOfSamples: STDDEV_3NFSC,
          },
          sharp: {
            value: SHARP3,
            rank: SHARP_3NRANK,
            NumberOfSamples: SHARP_3NFSC,
          },
          maxReturn: {
            value: MAXRETRA3,
            rank: MAXRETRA_3NRANK,
            NumberOfSamples: MAXRETRA_3NFSC,
          },
          trackingError: {
            value: TRKERROR3,
            rank: TRKERROR_3NRANK,
            NumberOfSamples: TRKERROR_3NFSC,
          },
        },
        fiveYear: {
          volatility: {
            value: STDDEV5,
            rank: STDDEV_5NRANK,
            NumberOfSamples: STDDEV_5NFSC,
          },
          sharp: {
            value: SHARP5,
            rank: SHARP_5NRANK,
            NumberOfSamples: SHARP_5NFSC,
          },
          maxReturn: {
            value: MAXRETRA5,
            rank: MAXRETRA_5NRANK,
            NumberOfSamples: MAXRETRA_5NFSC,
          },
          trackingError: {
            value: TRKERROR5,
            rank: TRKERROR_5NRANK,
            NumberOfSamples: TRKERROR_5NFSC,
          },
        },
      };
      return format.handleFeatureData({ data, BTYPE });
    },
  },
  tradeRule: { // 交易规则
    property: ['rateInfo.CURRENTDAYMARK',
      'rateInfo.STKTOCASH',
      'rateInfo.STKEXCHG',
      'baseInfo[0].FUNDEXCHG',
      'rateInfo.CASHBUY',
      'rateInfo.BAGTYPE',
      'baseInfo[0].BUY',
      'rateInfo.RDMCFMDATADAY',
      'riskInfo.tradeMarkList'],
    computed: ([CURRENTDAYMARK,
      STKTOCASH,
      STKEXCHG,
      FUNDEXCHG,
      CASHBUY,
      BAGTYPE,
      BUY,
      RDMCFMDATADAY,
      tradeMarkList]) => format.handleTradeRule({
      CURRENTDAYMARK,
      STKTOCASH,
      STKEXCHG,
      FUNDEXCHG,
      CASHBUY,
      BAGTYPE,
      BUY,
      RDMCFMDATADAY,
      tradeMarkList,
    }),
  },
  newFundTradeRule: { // 新基金交易规则
    property: ['rateInfo.CYCLE',
      'rateInfo.CURRENTDAYMARK',
      'baseInfo[0].ESTABDATE',
      'rateInfo.DRAWCFMDATADAY',
      'rateInfo.RGEND'],
    computed: ([cycle, currentDayMark, estabdate, DRAWCFMDATADAY, rgEnd]) => ({
      cycle,
      currentDayMark,
      estabdate,
      DRAWCFMDATADAY,
      rgEnd,
    }),
  },
  fundBonusPoints: { // 基金分红提示
    property: 'fundBonusPoints[0]',
    defaultValue: [],
    computed: (fundBonusPoints) => {
      const list = [];
      if (!isEmpty(fundBonusPoints)) {
        const bonus = fundBonusPoints?.BONUS ? parseFloat(fundBonusPoints?.BONUS).toFixed(4) : '';
        const fPTYPE = fundBonusPoints?.FPTYPE || '';
        const date = isEmpty(fundBonusPoints.EXDDATE)
          ? '--'
          : formatDate(new Date(fundBonusPoints.EXDDATE.replace(/-/g, '/')), 'yyyy-MM-dd');
        let text = `该基金近期有分红，每份分红${bonus}元在除息日(${date})从净值中先扣除，当日净值下降不影响实际收益。详情 ＞`;
        if (fPTYPE === 2) {
          text = '该基金近期有折算，折算期间净值会先除权，导致净值下降/上升，但不影响实际收益。详情 ＞';
        }
        list.push({
          type: 1,
          content: text,
          hotKey: ['详情 ＞'],
          url: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDividendDistribution?FCODE=${fundBonusPoints.FCODE}`,
          IsVerifyLogin: false,
          linkType: 2,
          adId: 0,
        });
      }
      return list;
    },
  },
  newMarketCode: { // 新市场代码
    property: 'baseInfo[0].NEWTEXCH',
    defaultValue: '',
    computed: (NEWTEXCH) => (isEmpty(NEWTEXCH) ? '--' : NEWTEXCH - 0),
  },
  fundAcRate: { // 基金AC费率
    property: ['FundACRateInfoV2Expansion', 'FundACRateInfoV2'],
    computed: ([expansion, fundACRateInfo]) => {
      const fundAcRate = [];
      const isRegularFund = expansion?.Feature?.indexOf('071') > -1;
      const isRollingHoldingFund = expansion?.Feature?.indexOf('074') > -1;
      // eslint-disable-next-line no-unused-expressions
      fundACRateInfo?.forEach((item) => {
        fundAcRate.push({
          acType: item?.ACTYPE,
          isRg: item?.ISRG,
          afstMax: item?.AFSTMAX,
          fundCode: item?.FCODE,
          matchCode: item?.MATCHCODE,
          tPoint1: item?.TPOINT1,
          tPoint2: item?.TPOINT2,
          betterType: item?.BETTER_TYPE,
        });
      });
      return {
        acRateList: fundAcRate,
        isRegularFund,
        isRollingHoldingFund,
      };
    },
  },
  assistantInfo: { // 智能助理信息
    property: ['FundXTChangeInfo.holdDate',
      'FundXTChangeInfo.fundManagerChangeDate',
      'uniqueInfo[0].SHARP1',
      'uniqueInfo[0].SHARP_1NRANK',
      'uniqueInfo[0].SHARP_1NFSC'],
    computed: ([holdDate,
      fundManagerChangeDate,
      sharp,
      sharpRank,
      sharpFsc]) => ({
      holdDate,
      fundManagerChangeDate,
      sharp,
      sharpRank,
      sharpFsc,
    }),
  },
  bottomMoreInfo: { // 底部更多信息
    property: ['baseInfo[0].FCODE',
      'baseInfo[0].SHORTNAME',
      'baseInfo[0].BFUNDTYPE',
      'rateInfo.DTZT',
      'baseInfo[0].RZDF',
      'baseInfo[0].FEATURE',
      'baseInfo[0].SYL_Z',
      'baseInfo[0].LINKZSB',
      'baseInfo[0].TJDIN'],
    computed: ([FCODE, SHORTNAME, BFUNDTYPE, DTZT, RZDF, FEATURE, SYL_Z, linkZSB, tjd]) => ({
      FCODE,
      SHORTNAME,
      BFUNDTYPE,
      DTZT,
      RZDF,
      FEATURE,
      SYL_Z,
      linkZSB,
      isSupportConditionalSheet: tjd - 0 === 1,
    }),
  },
  bottomRateInfo: { // 底部费率信息
    property: ['baseInfo[0].SOURCERATE',
      'baseInfo[0].RATE',
      'rateInfo.ISSALES',
      'rateInfo.MINSG',
      'rateInfo.SGZT',
      'rateInfo.SHZT',
      'baseInfo[0].TSRQ'],
    computed: ([
      sourceRate,
      rate,
      isSales,
      minSG,
      SGZT,
      SHZT,
      TSRQ]) => format.handleBottomRateInfo({
      sourceRate, rate, isSales, minSG, SGZT, SHZT, TSRQ,
    }),
  },
  bottomBuyInfo: { // 底部购买信息
    property: ['baseInfo[0].BAGTYPE', 'rateInfo.MINSG', 'rateInfo.MINSBSG'],
    computed: ([bagType, minSG, minSBSG]) => ({ bagType, minSG, minSBSG }),
  },
  isStopTrade: {
    property: ['rateInfo.FUNDTYPE', 'rateInfo.SGZT'],
    computed: (FUNDTYPE, SGZT) => FUNDTYPE !== '005' && ['封闭期', '暂停申购'].indexOf(SGZT) > -1,
  },
  isStopSH: {
    property: 'rateInfo.SHZT',
    computed: (SHZT) => ['封闭期', '暂停赎回'].indexOf(SHZT) > -1,
  },
  minSG: {
    property: 'rateInfo.MINSG',
    defaultValue: '--',
  },
  minSBSG: {
    property: 'rateInfo.MINSBSG',
    defaultValue: '--',
  },
  warnList: {
    property: 'riskInfo.warnList',
    defaultValue: [],
    computed: (warnList) => {
      if (isEmpty(warnList)) return [];
      const temp = [];
      warnList.forEach((item) => {
        temp.push({
          content: item.text,
          url: item?.link?.linkTo,
          linkType: item?.link?.linkType,
          type: item.type,
          date: item.date,
          hotKey: ['了解详情>'],
        });
      });
      return temp;
    },
  },
  newFundBuyProgressInfo: {
    property: ['rateInfo.CYCLE',
      'rateInfo.CURRENTDAYMARK',
      'baseInfo[0].ESTABDATE',
      'rateInfo.DRAWCFMDATADAY',
      'rateInfo.RGEND'],
    computed: ([cycle, currentDayMark, estabdate, DRAWCFMDATADAY, rgEnd]) => ({
      cycle,
      currentDayMark,
      estabdate,
      DRAWCFMDATADAY,
      rgEnd,
    }),
  },
  isSpecialRate: {
    property: 'rateInfo.MGREXP',
    computed: (MGREXP) => MGREXP?.indexOf('特殊') >= 0,
  },
  // eslint-disable-next-line max-len
  indexMarketInfo: { // 关联指数和业绩基准指数信息 市场号字段名一样, 但关联指数的市场是基本信息接口-newindextexch字段  业绩基准的市场是根据BENCHCODE去指数信息接口拿newindextexch字段
    property: ['indexDetail[0].INDEXNAME',
      'indexDetail[0].NEWINDEXTEXCH',
      'indexDetail[0].INDEXCODE',
      'baseInfo[0].BENCHCODE',
      'baseInfo[0].BENCH_CORR',
      'baseInfo[0].TRKERROR',
      'baseInfo[0].NEWINDEXTEXCH',
      'baseInfo[0].BENCHRATIO'],
    computed: ([INDEXNAME,
      NEWINDEXTEXCH,
      INDEXCODE,
      BENCHCODE,
      BENCH_CORR,
      TRKERROR,
      NEWTEXCH,
      BENCHRATIO]) => ({
      indexName: INDEXNAME?.replace('指数', ''),
      benchMarketCode: NEWINDEXTEXCH,
      benchCode: BENCHCODE,
      marketCode: NEWTEXCH,
      indexCode: INDEXCODE,
      benchCorr: isEmpty(BENCH_CORR) ? '--' : BENCH_CORR * 100,
      trkError: TRKERROR,
      benchRatio: isEmpty(BENCHRATIO) ? '--' : `${BENCHRATIO}%`,
    }),
  },
  fundCompany: 'baseInfo[0].JJGS',
  fundRelateTheme: 'fundRelateTheme',
  companyId: 'baseInfo[0].JJGSID',
};

export default new Model(property, replacedKeyFromPropertyName);
